//replaces table.html
import type { FC } from "react";

import { MiniFlexTable } from "app/components/React/Table/FlexTable/Mini/MiniFlexTable";
import { SWReactTable } from "app/components/React/Table/SWReactTable";
import { TableNoData } from "app/components/table-no-data/TableNoData";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import { WidgetLegendContainerV2 } from "app/dashboards/view-components/widget-legend/WidgetLegendContainer-v2";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

export interface ITableWidget extends IWidget<any> {
    onSort: () => {};
    onItemClick: () => {};
    onToggleSelection: () => {};
    selectAllPageRows: () => {};
    getSingleHeaderItem?: (a?) => {};
    getCompareBarsItems?: () => {};
    allRowsSelected: boolean;
    tableClassName?: string;
    errorConfig?: any;
}

export const TableTemplateV2: FC<IDashboardWidgetInterface<ITableWidget>> = (props) => {
    const { widget, className } = props;

    return (
        <>
            {widget.viewOptions.tableCompareLegend ? (
                <WidgetLegendContainerV2
                    widget={widget}
                    className="swWidget-legend audience-geography-table-legend"
                    items={widget.legendItems}
                    useNewLegends={widget.viewOptions.useNewLegends}
                    useBulletLegends={widget.viewOptions.useBulletLegends}
                />
            ) : null}
            {widget.metadata.options.tableType === "widgetTable" && !!widget.data?.Records?.length ? (
                <SWReactTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    onSort={widget.onSort}
                    onItemClick={widget.onItemClick}
                    onItemToggleSelection={widget.onToggleSelection}
                    onSelectAllRows={widget.selectAllPageRows}
                    allRowsSelected={widget.allRowsSelected}
                    className={widget.tableClassName}
                />
            ) : null}
            {widget.metadata.options.tableType === "swTable--simple" && !!widget.data?.Records?.length ? (
                <MiniFlexTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    tablePayload={{ items: widget.data.Items }}
                />
            ) : null}
            {widget.metadata.options.emptyResults ? <TableNoData config={widget.errorConfig} /> : null}
        </>
    );
};
